import React, { useState } from "react";
import Section from "../components/Section";
import TallerCard from "../components/TallerCard";
import { useCollection } from "../hooks/useCollection";

const Cultura = () => {
  const { docs: cultura, loading } = useCollection('cultura');
  const [paginaActual, setPaginaActual] = useState(1);
  const porPagina = 6;

  const totalPaginas = Math.ceil(cultura.length / porPagina);

  const cambiarPagina = (nuevaPagina) => {
    setPaginaActual(nuevaPagina);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const culturaPagina = cultura.slice(
    (paginaActual - 1) * porPagina,
    paginaActual * porPagina
  );

  return (
    <Section title="Cultura en la Casa">
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <div className="card-grid">
            {culturaPagina.map((taller, i) => (
              <TallerCard key={i} taller={taller} />
            ))}
          </div>

          {totalPaginas > 1 && (
            <div className="pagination">
              <button disabled={paginaActual === 1} onClick={() => cambiarPagina(paginaActual - 1)}>
                Anterior
              </button>
              {Array.from({ length: totalPaginas }, (_, i) => (
                <button
                  key={i + 1}
                  className={paginaActual === i + 1 ? "active" : ""}
                  onClick={() => cambiarPagina(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button disabled={paginaActual === totalPaginas} onClick={() => cambiarPagina(paginaActual + 1)}>
                Siguiente
              </button>
            </div>
          )}
        </>
      )}
    </Section>
  );
};

export default Cultura;
